// set constants for actions
export const MODAL_SET = 'MODAL_SET';

// nav actions
export const TOGGLE_NAV = 'TOGGLE_NAV';

// por actions
export const POR_EDIT_STATE = 'POR_EDIT_STATE'; // edit the state like setState does

// constants for multi location reducer
export const MULTI_VISIT = 'MULTI_VISIT'; // toggle to true if page has been visited
export const MULTI_GET_FILTERS    = 'MULTI_GET_FILTERS'; // make async request for filters (THUNK)
export const MULTI_SET_FILTERS    = 'MULTI_SET_FILTERS'; // set the filters after request
export const MULTI_SET_ERROR      = 'MULTI_SET_ERROR'; // set an error message
export const MULTI_OPEN_FILTER    = 'MULTI_OPEN_FILTER'; // open a filter for a chart
export const MULTI_EDIT_THRESHOLD    = 'MULTI_EDIT_THRESHOLD'; // edit a threshold for a chart
export const MULTI_ADD_THRESHOLD = 'MULTI_ADD_THRESHOLD' // add a new threshold
export const MULTI_REMOVE_THRESHOLD = 'MULTI_REMOVE_THRESHOLD' // remove a threshold
export const MULTI_EDIT_STAGE    = 'MULTI_EDIT_STAGE'; // edit a stage for a chart
export const MULTI_ADD_STAGE = 'MULTI_ADD_STAGE' // add a new stage
export const MULTI_REMOVE_STAGE = 'MULTI_REMOVE_STAGE' // remove a stage
export const MULTI_CLOSE_FILTER   = 'MULTI_CLOSE_FILTER'; // open a filter for a chart
export const MULTI_REMOVE_CHART   = 'MULTI_REMOVE_CHART'; // remove a chart
export const MULTI_ADD_CHART      = 'MULTI_ADD_CHART'; // add a chart
export const MULTI_CHANGE_COL_WIDTH    = 'MULTI_CHANGE_COL_WIDTH'; // change column width
export const MULTI_COPY_FILTER    = 'MULTI_COPY_FILTER'; // copy filters
export const MULTI_PASTE_FILTER   = 'MULTI_PASTE_FILTER'; // paste filters
export const MULTI_CHANGE_FILTER  = 'MULTI_CHANGE_FILTER'; // change the filters
export const MULTI_APPLY_FILTER   = 'MULTI_APPLY_FILTER'; // apply the filters (THUNK)
export const MULTI_CLEAR_ERROR    = 'MULTI_CLEAR_ERROR'; // clear the error message
export const MULTI_LOADING_DATA   = 'MULTI_LOADING_DATA'; // loading the data
export const MULTI_CLEAR_LOADING_STATE = 'MULTI_CLEAR_LOADING_STATE'; // clear the loading state
export const MULTI_SET_PLOT_DATA = 'MULTI_SET_PLOT_DATA'; // set the plot data after query
export const MULTI_CLOSE_SETTINGS = 'MULTI_CLOSE_SETTINGS'; // close the settings
export const MULTI_OPEN_SETTINGS = 'MULTI_OPEN_SETTINGS'; // open settings
export const MULTI_EDIT_CHART_LAYOUT = 'MULTI_EDIT_CHART_LAYOUT';
export const MULTI_EDIT_CHART_CONFIG = 'MULTI_EDIT_CHART_CONFIG';
export const MULTI_SET_APPLIED_FILTER = 'MULTI_SET_APPLIED_FILTER';
export const MULTI_CLEAR_FILTERS = 'MULTI_CLEAR_FILTERS'; // clear all the applied filters
export const MULTI_SET_AVAILABLE = 'MULTI_SET_AVAILABLE'; // set the available filters
export const MULTI_SHOW_STATS = 'MULTI_SHOW_STATS'; // display the stats panel
export const MULTI_CLOSE_STATS = 'MULTI_CLOSE_STATS'; // display the stats panel
export const MULTI_OPEN_LINE_STYLES = 'MULTI_OPEN_LINE_STYLES'; // display the line style panel
export const MULTI_CLOSE_LINE_STYLES = 'MULTI_CLOSE_LINE_STYLES'; // display the line style panel
export const MULTI_EDIT_CHART_LINE = 'MULTI_EDIT_CHART_LINE'; // edit a chart line
export const MULTI_EDIT_TRACE = 'MULTI_EDIT_TRACE'; // edit a chart line
export const MULTI_SET_BULK = 'MULTI_SET_BULK'; // sets bulk data
export const MULTI_SET_BULK_STAT = 'MULTI_SET_BULK_STAT'; // set bulk stats year data
export const MULTI_EDIT_Y_AXIS = 'MULTI_EDIT_Y_AXIS'; // edit the charts y axis
export const MULTI_SET_LOADING = 'MULTI_SET_LOADING'; // set the loading icon for a chart
export const MULTI_TOGGLE_SHOW_PANEL = 'MULTI_TOGGLE_SHOW_PANEL'; // multi toggle show panel
export const MULTI_CLEAR_THRESHOLDS = 'MULTI_CLEAR_THRESHOLDS'; // clear thresholds
export const MULTI_TOGGLE_FAVORITES = 'MULTI_TOGGLE_FAVORITES'; // toggle the favorites
export const MULTI_EDIT_DATUM = 'MULTI_EDIT_DATUM'; // sets the datum to a value or null
export const MULTI_TOGGLE_DATUM = 'MULTI_TOGGLE_DATUM'; // toggle display datum;
export const MULTI_SET_ACTIVE_CHART = 'MULTI_SET_ACTIVE_CHART'; // set the active chart
export const MULTI_CLEAR_STAGES = 'MULTI_CLEAR_STAGES'; // clears the stages
export const MULTI_SET_HOVER_MAP = 'MULTI_SET_HOVER_MAP'; // set the map to display
export const MULTI_SET_LAST_APPLIED = 'MULTI_SET_LAST_APPLIED'; // set the last applied filters

// bulky actions
export const BULK_SET_ALL = 'BULK_SET_ALL'; // makes a request for all records

// auth actions
export const AUTH_SET = 'AUTH_SET';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_MESSAGE = 'AUTH_MESSAGE';

// help actions
export const START_HELP = 'START_HELP'
export const END_HELP = 'END_HELP'

export const ADVANCE_HELP = 'ADVANCE_HELP'
export const BACK_HELP = 'BACK_HELP'


// WEBPACK FOOTER //
// ./src/store/actions/actions.js